/**
 * Test IDs for QA automation.
 */
export const testIds = {
  invoicePaymentFormNote: "invoice-payment-form-note",
} as const;
